module.exports = __webpack_public_path__ + "img/des1.cadaf53e.jpg";